module.exports = __webpack_public_path__ + "static/media/logo.0e032960.svg";


//////////////////
// WEBPACK FOOTER
// ./src/logo.svg
// module id = 53
// module chunks = 0